import { render } from "./header.vue?vue&type=template&id=5c5638b3&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=5c5638b3&scoped=true&lang=less"

import exportComponent from "D:\\createProject\\吉幼美官网\\web\\project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5638b3"]])

export default __exports__